export default __webpack_public_path__ + "static/media/InnerTune1.cd1c79fe.png";